import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { CurrentWorks } from './components/CurrentWorks';
import { Gallery } from './components/Gallery';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Login } from './pages/Login';
import { SimpleAdmin } from './pages/SimpleAdmin';
import './App.css';

const LandingPage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <CurrentWorks />
      <Gallery />
      <Testimonials />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <SimpleAdmin />
                </ProtectedRoute>
              }
            />
          </Routes>

          <Toaster 
            position="top-center"
            toastOptions={{
              style: {
                background: '#ffffff',
                color: '#1f2937',
                border: '2px solid #4A7BA7',
                padding: '16px',
                fontSize: '16px',
                fontWeight: '600',
                boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                zIndex: 999999
              },
              className: 'toast-notification',
              duration: 4000,
            }}
          />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
